export default __webpack_public_path__ + "static/media/insta-pc.07058bd1.png";